import type { ReactNode } from 'react';
import { Text } from '@repletoryreach/sdk-ui';

/**
 * A table cell that carries a value and its qualifier: the organisation and its
 * slug, the plan and its price, the moment and how long ago it was.
 *
 * This is the pattern that lets a dense table stay readable, because the
 * qualifier a person needs to disambiguate a row is on the row rather than in
 * a column of its own.
 */
export function TwoLineCell({ primary, secondary, leading, title }: {
  primary: ReactNode;
  secondary?: ReactNode;
  /** An avatar, logo or flag, vertically centred against both lines. */
  leading?: ReactNode;
  /** Native tooltip for a primary value that may truncate. */
  title?: string;
}) {
  const lines = (
    <span style={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 0 }}>
      <Text role="bodySmall" fw={600} lineClamp={1} title={title}>{primary}</Text>
      {secondary != null && secondary !== '' && (
        <Text role="caption" c="var(--rr-color-text-muted)" lineClamp={1}>{secondary}</Text>
      )}
    </span>
  );
  if (!leading) return lines;
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
      <span style={{ flexShrink: 0, display: 'inline-flex' }}>{leading}</span>
      {lines}
    </span>
  );
}
